export default __webpack_public_path__ + "static/media/sunside.72f72adf.png";